import Button from '@mui/material/Button';
import Form from '../baseComponents/form';
import TextArea from '../baseComponents/textarea';
import useAnswerForm from '../../../hooks/useAnswerForm';
import useLayoutStyles from '../../layout/useLayoutStyles';
import useGlobalStyles from '../../useGlobalStyles';

/**
 * NewAnswerPage component allows users to submit an answer to a specific question.
 */
const NewAnswerPage = () => {
  const { classes: layoutClasses } = useLayoutStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const { text, textErr, setText, postAnswer } = useAnswerForm();

  return (
    <div className={layoutClasses.pageContainer}>
      <Form>
        <TextArea
          title={'Answer Text'}
          id={'answerTextInput'}
          val={text}
          setState={setText}
          err={textErr}
        />
        <div className={layoutClasses.btnIndicatorContainer}>
          <Button
            className={`${globalClasses.button} ${layoutClasses.formPostBtn}`}
            onClick={() => {
              setTimeout(() => {
                postAnswer();
              }, 200);
            }}>
            Post Answer
          </Button>
          <div className={globalClasses.mandatoryField}>
            *{' '}
            <span className={globalClasses.indicatesMandatoryText}>indicates mandatory fields</span>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default NewAnswerPage;
